import React, { Component } from 'react';
import AjaxSpinner, { AjaxSpinnerProps } from '@/components/AjaxSpinner';

import { MODAL_LOADING } from '../../../util/enums/EnumModals';

// eslint-disable-next-line camelcase
class ModalLoading_WITH_DEPRICATED_STATIC_METHODS extends Component<AjaxSpinnerProps> {
  static modalType() {
    return MODAL_LOADING;
  }

  static reducer() {
    return null;
  }

  static title() {
    return 'Loading...';
  }

  render() {
    return <AjaxSpinner {...this.props} />;
  }
}

// eslint-disable-next-line camelcase
export default ModalLoading_WITH_DEPRICATED_STATIC_METHODS;
